import React,{useState,useEffect} from "react";
import { Facebook, Instagram, Youtube, Linkedin, Mail, Phone, MapPin, Clock } from "lucide-react";
import "./footer.css";
import { FaWhatsapp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';


export default function Footer() {
    const navigate = useNavigate();
    const [config, setConfig] = useState(null);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [socialLinks, setSocialLinks] = useState(null);

  const handleRaiseQuery = () => {
    navigate("/contactus"); 
  };

    useEffect(() => {
    fetch("/config.json")
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(err => console.error("Failed to load config.json:", err));
  }, []);

  useEffect(() => {
  fetch("/data.json")  
    .then(res => res.json())
    .then(data => setSocialLinks(data))
    .catch(err => console.error("Failed to load data.json:", err));
}, []);

  const iconMap = {
  FacebookLink: <Facebook size={24} />,
  InstagramLink: <Instagram size={24} />,
  WhatsappLink: <FaWhatsapp size={24} />,
  LinkedinLink: <Linkedin size={24} />,
  YoutubeLink: <Youtube size={24} />
};



  // Subscribe handler
  const handleSubscribe = () => {
    if (!config) return;

    fetch(`${config.BASE_URL}${config.SUBSCRIBERS}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setMessage("Subscribed successfully!");
          setEmail("");
        } else {
          setMessage(data.message || "Subscription failed.");
        }
      })
      .catch(err => {
        console.error(err);
        setMessage("Error connecting to server.");
      });
  };

  return (
    <footer className="site-footer">
      <div className="site-footer-content">

        {/* Logo on far left */}
        <div className="site-footer-logo-container">
          <img src="/TRADE_MARK_HD.png" alt="logo" className="site-footer-logo" />
        </div>

        {/* Services */}
        <div className="site-footer-section"> 
          <h3>Services</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/products">Products</a></li>
            <li><a href="#">Services</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="site-footer-section">
          <h3>Contact</h3>
          <p><Phone size={18} /> +91 8142678901</p>
          <p><Mail size={18} /> info@robocoupler.com</p>
          <p><MapPin size={18} /> Opp ZION Church, MVP Colony, Sector 12, Vizag</p>
          <p><Clock size={18} /> Mon-Sat : 10AM-4PM Sun : 10AM-12:30PM</p>
        </div>

        {/* Policies */}
        <div className="site-footer-section">
          <h3>Policies</h3>
          <ul>
          <li><HashLink smooth to="/terms#terms-and-conditions">Terms & Conditions</HashLink></li>
          <li><HashLink smooth to="/terms#privacy-policy">Privacy Policy</HashLink></li>
          <li><HashLink smooth to="/terms#refund-policy">Refund Policy</HashLink></li>
        </ul>
        </div>

        {/* Raise a Query Button */}
        <div className="site-footer-section">
          <h3>Have a Query?</h3>
          <button className="raise-query-btn" onClick={handleRaiseQuery}>Raise Query</button>
        </div>

        {/* Social Media */}
        <div className="site-footer-section">
          <h3>Follow Us</h3>
          <div className="site-footer-social">
            {socialLinks &&
              Object.keys(iconMap).map((key) => (
                <a
                  key={key}
                  href={socialLinks[key]}  
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {iconMap[key]}
                </a>
              ))}
          </div>

          {/* Newsletter */}
          <div className="newsletter">
            <input type="email" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)}/>
            <button onClick={handleSubscribe}>Subscribe</button>
            {message && <p>{message}</p>}
          </div>
        </div>
      </div>
      <div className="site-footer-bottom">
        © Copyrighted by Robocoupler Industries Pvt. Ltd.
      </div>
    </footer>
  );
}
